export default __webpack_public_path__ + "static/dupertuis-690a60164c2627a96e40ba33cc40252a.png";